import React from 'react';
import { buildVersionedClassNames } from '@op/opds.opux-utilities';
import Control from './_control';

/**
 * Renders segments in pagination component.
 */
const PaginationSegments = _ref => {
  let {
    activePageIndex,
    arrowControls,
    dispatchWithPageCount,
    hideSegments,
    indicators,
    localizedPageLabel,
    numberedControlLabels,
    pageCount,
    pages
  } = _ref;
  if (hideSegments) {
    return null;
  }
  return /*#__PURE__*/React.createElement("ul", {
    "aria-hidden": indicators,
    className: buildVersionedClassNames('ds-pagination__list', {
      'ds-pagination__list--indicators': indicators,
      'ds-pagination__list--no-arrow-controls': arrowControls === 'none'
    })
  }, pages.map((pageNumberIndex, index) => {
    const hasCustomAriaLabels = numberedControlLabels && numberedControlLabels.length === pageCount;
    const ariaLabel = hasCustomAriaLabels ? numberedControlLabels[pageNumberIndex] : localizedPageLabel + " " + (pageNumberIndex + 1);
    if (indicators) {
      return /*#__PURE__*/React.createElement("li", {
        key: index + pageNumberIndex
      }, /*#__PURE__*/React.createElement("div", {
        className: buildVersionedClassNames('ds-pagination__list__item', {
          'ds-pagination__list__item--indicator': true,
          'ds-pagination__list__item--active': activePageIndex === pageNumberIndex
        })
      }));
    }
    return typeof pageNumberIndex === 'number' ? /*#__PURE__*/React.createElement(Control, {
      activePage: activePageIndex,
      ariaLabel: ariaLabel,
      index: pageNumberIndex,
      key: ariaLabel,
      onClick: event => {
        event.preventDefault();
        dispatchWithPageCount({
          index: pageNumberIndex,
          type: 'PAGE'
        });
      }
    }, pageNumberIndex + 1) : /*#__PURE__*/React.createElement("li", {
      key: index + pageNumberIndex
    }, /*#__PURE__*/React.createElement("div", {
      className: buildVersionedClassNames('ds-pagination__list__item', {
        'ds-pagination__list__item--ellipsis': true
      })
    }, "..."));
  }));
};
export default PaginationSegments;